/** Datas de prazo chegam da API como `AAAA-MM-DD` (sem hora). Nunca passar por `new Date()`: em UTC-3 o dia
 *  muda (constituição §6.1). */
export function formatarData(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) throw new Error(`data inválida: ${iso}`);
  return `${m[3]}/${m[2]}/${m[1]}`;
}

const SEMANA = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];

export function diaDaSemana(iso: string): string {
  const [a, m, d] = iso.split("-").map(Number) as [number, number, number];
  return SEMANA[new Date(Date.UTC(a, m - 1, d)).getUTCDay()]!;
}

/** `AAAA-MM-DD` → `dd/mm` (listas, onde o ano é o corrente quase sempre). */
export function formatarDataCurta(iso: string): string {
  return formatarData(iso).slice(0, 5);
}

const SEMANA_CURTA = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];

export function diaDaSemanaCurto(iso: string): string {
  const [a, m, d] = iso.split("-").map(Number) as [number, number, number];
  return SEMANA_CURTA[new Date(Date.UTC(a, m - 1, d)).getUTCDay()]!;
}

const DIA_SP = new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit" });

/** Instante (timestamp com fuso, ex.: "atualizado em") → `dd/mm` no fuso do escritório. Não é para data de prazo. */
export function diaDoInstante(iso: string): string {
  return DIA_SP.format(new Date(iso));
}

const DIA_HORA_SP = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
});

/** Instante → `dd/mm hh:mm` no fuso do escritório (trilha, histórico). */
export function diaHoraDoInstante(iso: string): string {
  return DIA_HORA_SP.format(new Date(iso)).replace(",", "");
}
